import { useSelector } from 'react-redux';
import { Redirect, useParams } from 'react-router';
import { HomeownersSetupFlowPage } from 'accounts/pages/homeowners/setup-flow/setup-flow';
import Property from 'pages/Accounts/Pages/YourPortfolio/Properties/Property/Property';
import { selectAccountProperties } from 'store/redux/homeowner-accounts/selectors';

export function PropertyPagePicker() {
  const { propertyId, unitId } =
    useParams<Record<'propertyId' | 'unitId', string>>();
  const accountProperties = useSelector(selectAccountProperties);

  const property = accountProperties?.find(
    (accountProperty) => accountProperty.basicInfo.propertyId === propertyId,
  );

  if (!property) {
    return <Redirect to="/accounts/portfolio/properties" />;
  }

  const isSetupFlowComplete = property?.units?.every(
    (unit: any) => unit.isSetupFlowCompleted,
  );

  const isPostInspectionFlowComplete = property?.units?.every(
    (unit: any) => !unit.hasImprovementsFlowOpen && !unit.hasPricingFlowOpen,
  );

  const isLandlordFlowComplete = property?.units?.every(
    (unit: any) => !unit.hasLandlordFlowOpen,
  );

  const isPreMoveOutFlowCompleted = property?.units?.every(
    (unit: any) => !unit.hasHomeownerPreMoveOutFlowOpen,
  );

  if (
    isSetupFlowComplete &&
    isPostInspectionFlowComplete &&
    isLandlordFlowComplete &&
    isPreMoveOutFlowCompleted
  ) {
    return <Property propertyId={propertyId} unitId={unitId} />;
  }

  return <HomeownersSetupFlowPage />;
}
